import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d280f57&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHome: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/SectionHome.vue').default,SectionWork: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/SectionWork.vue').default,SectionProcess: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/SectionProcess.vue').default,SectionAbout: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/SectionAbout.vue').default})
